export default __webpack_public_path__ + "static/media/tough-task-remover.33ea8cc1.jpeg";